import React, { useEffect, useRef, useState  } from 'react';
import { useTranslation } from 'react-i18next';
import './Board.css';
import { useSound } from './sfx/SoundProvider';

// import longTournamentSocket from './longTournamentSocket';
import longTournamentSocket, {
  ensureLongTournamentSocketAuthAndConnect,
  safeEmit,
} from './longTournamentSocket';

import { useLocation, useNavigate } from 'react-router-dom';

const LongTournamentBackgammonBoardDisplay = ({
  // ---- Ваши пропсы ----
  longBoardState,
  longOnPointClick,
  longHandleDragOver,
  longHandleDragStart,
  longHandleDrop,
  longFirstRolls,
  longHasRolledDice,
  firstMoveComplete,
  longCurrentTurn,
  longMyColor = 'white', // 'white' или 'black'
  longRolledDice,
  longShowUndoButton,
  longHandleUndoMove,
  longNumberMove,
  longConfirmMove,
  handleLongRollDiceClick,
  longWhiteOffBoard,
  longBlackOffBoard,
  longFirstMoveComplete,
  longLeaveTable,
  longMoveHistory,
  longRollEnabled,
  player1Time,
  player2Time,
  onResign,
  resignDisabled,
  player1Profile,
  player2Profile,
  longPlayer1Name,
  longPlayer2Name,
  tournamentStageLabel,
  tournamentPrize,
  autoRoll,
  autoConfirm,
  onToggleAutoRoll,
  onToggleAutoConfirm,
  // ... и т.д.
}) => {
  const { t: translate, i18n } = useTranslation();

  /* ===================== SFX ===================== */
  const { play } = useSound();
  const playSfx = (name) => {
    try {
      const p = play?.(name);
      if (p && typeof p.then === 'function') p.catch(() => {});
    } catch (_) {}
  };

  // «goodluck» после автопервого броска — под мобильный жест
  const goodluckPlayedRef     = useRef(false);
  const gestureHandlerRef     = useRef(null);
  const suppressClickUntilRef = useRef(0);


    // 🔽 НОВОЕ: отслеживаем появление/исчезновение кубиков
  // чтобы звук игрался по факту броска, а не по клику на кнопку
  const hadDiceRef = useRef(false);
  const prevFirstRollsRef = useRef({
    player1Roll: null,
    player2Roll: null,
  });


  const location = useLocation();
  const navigate  = useNavigate();
  const [isSocketDown, setIsSocketDown] = useState(false);


  // SFX-обёртки для UI-колбеков
  const onPointClickSfxGuarded = (realIndex) => {
    if (Date.now() > suppressClickUntilRef.current) playSfx('click');
    longOnPointClick?.(realIndex);
  };
  const longHandleDragStartSfx = (e, fromIndex, checkerIdx) => {
    playSfx('click');
    longHandleDragStart?.(e, fromIndex, checkerIdx);
  };
  const longHandleDropSfx = (e, toIndex) => {
    playSfx('drop');
    longHandleDrop?.(e, toIndex);
  };
  const longHandleUndoMoveSfx = () => {
    playSfx('cancel');
    longHandleUndoMove?.();
  };
  const longConfirmMoveSfx = () => {
    playSfx('ok');
    longConfirmMove?.();
  };
  // const handleLongRollDiceClickSfx = () => {
  //   playSfx('dice');
  //   handleLongRollDiceClick?.();
  // };

    const handleLongRollDiceClickSfx = () => {
    // 🎲 Звук кубиков теперь играет не по клику,
    // а по фактическому появлению кубиков в состоянии longRolledDice/longFirstRolls
    handleLongRollDiceClick?.();
  };

  const onResignSfx = () => {
    playSfx('pass'); // звуковой фидбек сдачи
    onResign?.();
  };

  /* ===================== Профили/аватарки ===================== */
  const p1 = player1Profile || {};
  const p2 = player2Profile || {};

  const p1Name = longPlayer1Name ?? p1.name ?? p1.username ?? 'Player 1';
  const p2Name = longPlayer2Name ?? p2.name ?? p2.username ?? 'Player 2';

  // === avatar utils (без двойного http) ===
  const RAW_API =
    (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_API_ORIGIN || import.meta.env?.VITE_API_URL)) ||
    process.env.REACT_APP_API_ORIGIN ||
    process.env.REACT_APP_API_URL ||
    '';

  const PAGE_PROTOCOL = (typeof window !== 'undefined' && window.location?.protocol) || 'http:';
  const PAGE_HOST     = (typeof window !== 'undefined' && window.location?.hostname) || 'localhost';
  const ENV_PORT =
    (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_PORT) ||
    process.env.REACT_APP_PORT ||
    (typeof window !== 'undefined' && window.location?.port === '3001' ? '5000' : '');

  let API_ORIGIN = '';
  if (/^https?:\/\//i.test(RAW_API)) {
    API_ORIGIN = RAW_API.replace(/\/+$/, '');
  } else if (RAW_API) {
    const hasPort = /:\d+$/.test(RAW_API);
    API_ORIGIN = `${PAGE_PROTOCOL}//${RAW_API}${hasPort ? '' : (ENV_PORT ? `:${ENV_PORT}` : '')}`.replace(/\/+$/, '');
  } else {
    API_ORIGIN = `${PAGE_PROTOCOL}//${PAGE_HOST}${ENV_PORT ? `:${ENV_PORT}` : ''}`.replace(/\/+$/, '');
  }

  const DEFAULT_AVATAR =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96">
         <circle cx="48" cy="48" r="46" fill="#2b2b2b" stroke="#999" stroke-width="2"/>
         <text x="50%" y="54%" text-anchor="middle" font-family="Inter,Arial" font-size="28" fill="#ddd">BQ</text>
       </svg>`
    );

  function resolveAvatarSrc(raw) {
    const s = String(raw || '').replace(/\\/g, '/').trim();
    if (!s) return DEFAULT_AVATAR;
    if (/^https?:\/\//i.test(s)) return s;
    if (/^\/?uploads\//i.test(s) || /^\/?api\/uploads\//i.test(s)) {
      return `${API_ORIGIN}/${s.replace(/^\/+/, '')}`;
    }
    return s.startsWith('/') ? s : `/${s}`;
  }





    const formatPrize = (v) => {
    if (v == null) return '';
    const n = Number(v);
    return Number.isFinite(n) ? n.toLocaleString(i18n.language || 'ru') : String(v);
  };
  const stageClass = (() => {
    const s = String(tournamentStageLabel || '').toLowerCase();
    if (s.includes('полу') || s.includes('semi')) return 'semifinal';
    if (s.includes('финал') || s.includes('final')) return 'final';
    return '';
  })();

  const displayStageLabel = (() => {
    const raw = String(tournamentStageLabel || '').trim();
    const value = raw.toLowerCase();

    if (!raw) return '';
    if (value.includes('полу') || value.includes('semi')) {
      return translate('jackpotBoard.stage.semifinal');
    }
    if (value.includes('финал') || value.includes('final')) {
      return translate('jackpotBoard.stage.final');
    }
    if (value.includes('квалиф') || value.includes('qualif')) {
      return translate('jackpotBoard.stage.qualification');
    }
    if (value.includes('rebuy')) {
      return translate('jackpotBoard.stage.rebuy');
    }

    return raw;
  })();

  const p1Src = resolveAvatarSrc(player1Profile?.avatar);
  const p2Src = resolveAvatarSrc(player2Profile?.avatar);

  // пробный прелоад аватарок (hook — всегда вызывается)
  useEffect(() => {
    const test = (label, url) => {
      if (!url || url === DEFAULT_AVATAR) {
        console.warn(`[AVATAR][probe] ${label}: url пустой или дефолт →`, url);
        return;
      }
      const img = new Image();
      img.onload  = () => console.log(`[AVATAR][probe] ${label}: OK 200 →`, url);
      img.onerror = (e) =>  console.warn(`[AVATAR][probe] ${label}: ERROR →`, url, e);
      img.src = url;
    };
    test('P1', p1Src);
    test('P2', p2Src);
  }, [p1Src, p2Src]);

  /* ===================== Разбиение доски ===================== */
  const boardValid = Array.isArray(longBoardState) && longBoardState.length === 24;

  const firstBlack = boardValid ? longBoardState.slice(0, 12) : [];
  const secondBlack = boardValid ? longBoardState.slice(12) : [];
  const firstWhite = boardValid ? longBoardState.slice(12) : [];
  const secondWhite = boardValid ? longBoardState.slice(0, 12).reverse() : [];

  function OffBoardStack({ checkers, color }) {
    return (
      <div className="off-stack">
        {(checkers || []).map((_, i) => (
          <div key={i} className={`checker ${color}`} />
        ))}
      </div>
    );
  }

  const fmt = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  console.log('[C-4] props.longBoardState len=', Array.isArray(longBoardState) ? longBoardState.length : 'N/A');

  const diceImages = {
    white: {
      1: '/img/k1-white-1.png',
      2: '/img/k1-white-2.png',
      3: '/img/k1-white-3.png',
      4: '/img/k1-white-4.png',
      5: '/img/k1-white-5.png',
      6: '/img/k1-white-6.png',
    },
    black: {
      1: '/img/k1-black-1.png',
      2: '/img/k1-black-2.png',
      3: '/img/k1-black-3.png',
      4: '/img/k1-black-4.png',
      5: '/img/k1-black-5.png',
      6: '/img/k1-black-6.png',
    },
  };

  const isMyTurn =
    (longMyColor === 'white' && longCurrentTurn === 'player1') ||
    (longMyColor === 'black' && longCurrentTurn === 'player2');

  const canConfirmMove =
    isMyTurn &&
    longHasRolledDice &&
    longNumberMove === 0;

  /* ===================== Рендер стакованных шашек ===================== */
  function renderStackedCheckers(point, { isTopRow, realIndex }) {
    const checkers = Array.isArray(point) ? point : [];
    const visible  = checkers.slice(0, 5); // максимум 5
    const total    = checkers.length;

    return visible.map((checker, i) => {
      if (!checker || !checker.color) return null;
      const color = String(checker.color).toLowerCase();
      const showCount = total > 5 ? (isTopRow ? i === visible.length - 1 : i === 0) : false;

      return (
        <div
          key={i}
          className={`checker ${color}`}
          draggable="true"
          onDragStart={(e) => longHandleDragStartSfx(e, realIndex, i)}
          style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {showCount && <span className="stack-count">{total}</span>}
        </div>
      );
    });
  }

  /* ===================== Ряды (white/black) ===================== */
  const renderWhiteTopRow = () => (
    <div className="top-row">
      {(firstWhite || []).map((point, idx) => {
        const realIndex = 24 - idx - 1;
        return (
          <div
            key={idx}
            className={`point-container p${idx}`}
            onClick={() => onPointClickSfxGuarded(realIndex)}
            onDragOver={longHandleDragOver}
            onDrop={(e) => longHandleDropSfx(e, realIndex)}
          >
            <span>{idx + 13}</span>
            {renderStackedCheckers(point, { isTopRow: true, realIndex })}
          </div>
        );
      })}
    </div>
  );

  const renderWhiteBottomRow = () => (
    <div className="bottom-row">
      {(secondWhite || []).map((point, idx) => {
        const realIndex = idx;
        return (
          <div
            key={idx}
            className={`point-containerd r${idx}`}
            onClick={() => onPointClickSfxGuarded(realIndex)}
            onDragOver={longHandleDragOver}
            onDrop={(e) => longHandleDropSfx(e, realIndex)}
          >
            {renderStackedCheckers(point, { isTopRow: false, realIndex })}
            <span>{12 - idx}</span>
          </div>
        );
      })}
    </div>
  );

  const renderBlackTopRow = () => {
    const blackTopReversed = [...firstBlack].reverse();
    return (
      <div className="top-row">
        {blackTopReversed.reverse().map((point, idx) => {
          const realIndex = 11 - idx;
          const label = 13 + idx;
          return (
            <div
              key={idx}
              className={`point-container p${idx}`}
              onClick={() => onPointClickSfxGuarded(realIndex)}
              onDragOver={longHandleDragOver}
              onDrop={(e) => longHandleDropSfx(e, realIndex)}
            >
              <span>{label}</span>
              {renderStackedCheckers(point, { isTopRow: true, realIndex })}
            </div>
          );
        })}
      </div>
    );
  };

  const renderBlackBottomRow = () => {
    const blackBottomUnReversed = [...secondBlack].reverse(); // 12..23
    return (
      <div className="bottom-row">
        {blackBottomUnReversed.map((point, idx) => {
          const realIndex = 12 + idx;
          const label = 12 - idx;
          return (
            <div
              key={idx}
              className={`point-containerd r${idx}`}
              onClick={() => onPointClickSfxGuarded(realIndex)}
              onDragOver={longHandleDragOver}
              onDrop={(e) => longHandleDropSfx(e, realIndex)}
            >
              {renderStackedCheckers(point, { isTopRow: false, realIndex })}
              <span>{label}</span>
            </div>
          );
        })}
      </div>
    );
  };



  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    const fromUrl = qs.get('tableId'); // что в урле

    // если в урле нет, пробуем достать из local/sessionStorage
    const fromLongAnchor =
      localStorage.getItem('long:lastActiveTableId') ||
      sessionStorage.getItem('long:lastActiveTableId') ||
      localStorage.getItem('tableId') ||
      sessionStorage.getItem('tableId');

    const effectiveId = Number(fromUrl || fromLongAnchor);
    const username    = localStorage.getItem('username') || '';
    const token       = localStorage.getItem('token') || '';

    if (!effectiveId) {
      console.warn('[LONG] нет tableId ни в url, ни в localStorage');
      return;
    }

    // если в урле id не было — аккуратно дописываем ?tableId=...
    if (!fromUrl) {
      const nextSearch = `?tableId=${effectiveId}`;
      if (location.search !== nextSearch) {
        navigate({ pathname: location.pathname, search: nextSearch }, { replace: true });
      }
    }

    try {
      longTournamentSocket.auth = { token, username };
    } catch {}

    const joinAndFetch = () => {
      const tableId = effectiveId;

      longTournamentSocket.emit('long_tournament_joinTable', { tableId, username });
      longTournamentSocket.emit('longTournament_joinTable',   { tableId, username });
      longTournamentSocket.emit('tournamentMatch_joinTable',  { tableId, username });

      // если снапшот через ack тебе НЕ нужен — можно вообще без callback
      longTournamentSocket.emit('long_fetchTournamentData', tableId, () => {});
      longTournamentSocket.emit('fetchLongTournamentData',  tableId);
      longTournamentSocket.emit('fetchTournamentData',      tableId);
    };

    if (longTournamentSocket.connected) {
      joinAndFetch();
    } else {
      longTournamentSocket.connect();
      longTournamentSocket.once('connect', joinAndFetch);
    }

    longTournamentSocket.on('reconnect', joinAndFetch);

    return () => {
      longTournamentSocket.off('connect', joinAndFetch);
      longTournamentSocket.off('reconnect', joinAndFetch);
    };
  }, [location.pathname, location.search, navigate]);


  // useEffect(() => {
  //   const qs = new URLSearchParams(location.search);
  //   const tableId  = Number(qs.get('tableId'));
  //   const username = localStorage.getItem('username') || '';
  //   const token    = localStorage.getItem('token') || '';

  //   if (!tableId) return;

  //   // 1) auth ДО connect
  //   try { longTournamentSocket.auth = { token, username }; } catch {}

  //   const joinAndFetch = () => {
  //     // 2) join (несколько вариантов имён — один из них точно есть на бэке)
  //     longTournamentSocket.emit('long_tournament_joinTable', { tableId, username });
  //     longTournamentSocket.emit('longTournament_joinTable',   { tableId, username });
  //     longTournamentSocket.emit('tournamentMatch_joinTable',  { tableId, username });

  //     // 3) запрос снимка стола
  //     // ВАРИАНТ А: через ack-колбэк — предпочтительно
  //     longTournamentSocket.emit('long_fetchTournamentData', tableId, (snapshot) => {
  //       // snapshot → setState(...) твоего борда
  //       // например: setLongStateFromSnapshot(snapshot)
  //     });

  //     // ВАРИАНТ Б: если на бэке без ack — просто триггерим событие,
  //     // а слушатель у тебя уже есть ниже в компоненте
  //     longTournamentSocket.emit('fetchLongTournamentData', tableId);
  //     longTournamentSocket.emit('fetchTournamentData',     tableId);
  //   };

  //   // 4) если уже подключены — сразу, иначе дождаться connect
  //   if (longTournamentSocket.connected) {
  //     joinAndFetch();
  //   } else {
  //     longTournamentSocket.connect();
  //     longTournamentSocket.once('connect', joinAndFetch);
  //   }

  //   // 5) при реконнекте — повторить (иначе после обрыва снова пусто)
  //   longTournamentSocket.on('reconnect', joinAndFetch);

  //   return () => {
  //     longTournamentSocket.off('connect', joinAndFetch);
  //     longTournamentSocket.off('reconnect', joinAndFetch);
  //   };
  // }, [location.search, navigate]);








  /* ===================== SFX: Good luck один раз ===================== */
  useEffect(() => {
    const ready =
      Number.isInteger(longFirstRolls?.player1Roll) &&
      Number.isInteger(longFirstRolls?.player2Roll);

    if (!ready) return;
    if (goodluckPlayedRef.current) return;

    if (gestureHandlerRef.current) {
      window.removeEventListener('pointerdown', gestureHandlerRef.current);
      gestureHandlerRef.current = null;
    }

    const onFirstGesture = async () => {
      if (goodluckPlayedRef.current) return;
      try {
        const r = play?.('goodluck');
        if (r && typeof r.then === 'function') await r;
      } catch (_) {
        // ignore
      } finally {
        goodluckPlayedRef.current = true;
        suppressClickUntilRef.current = Date.now() + 250;
        window.removeEventListener('pointerdown', onFirstGesture);
        gestureHandlerRef.current = null;
      }
    };

    try {
      const maybe = play?.('goodluck');
      if (maybe && typeof maybe.then === 'function') {
        maybe.then(() => {
          goodluckPlayedRef.current = true;
          suppressClickUntilRef.current = Date.now() + 250;
        }).catch(() => {
          if (!goodluckPlayedRef.current) {
            gestureHandlerRef.current = onFirstGesture;
            window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
          }
        });
      } else {
        gestureHandlerRef.current = onFirstGesture;
        window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
      }
    } catch (_) {
      gestureHandlerRef.current = onFirstGesture;
      window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
    }

    return () => {
      if (gestureHandlerRef.current) {
        window.removeEventListener('pointerdown', gestureHandlerRef.current);
        gestureHandlerRef.current = null;
      }
    };
  }, [longFirstRolls, play]);



  // 🔊 Звук кубиков при обычных бросках (ручных и авто, своих и оппонента)
  useEffect(() => {
    const hasDice =
      Array.isArray(longRolledDice) && longRolledDice.length > 0;

    // Переход "не было кубиков" → "появились кубики"
    if (hasDice && !hadDiceRef.current) {
      hadDiceRef.current = true;
      playSfx('dice');
    }
    // Переход "кубики были" → "кубиков нет" (конец хода)
    else if (!hasDice && hadDiceRef.current) {
      hadDiceRef.current = false;
    }
  }, [longRolledDice, playSfx]);


  // 🔊 Звук кубиков при первых бросках (определение, кто ходит первым)
  useEffect(() => {
    if (!longFirstRolls) return;

    const prev = prevFirstRollsRef.current || {};
    const curr = longFirstRolls;

    const p1Changed =
      Number.isInteger(curr.player1Roll) &&
      curr.player1Roll !== prev.player1Roll;

    const p2Changed =
      Number.isInteger(curr.player2Roll) &&
      curr.player2Roll !== prev.player2Roll;

    // Если у кого-то из игроков появился новый первый бросок — играем звук
    if (p1Changed || p2Changed) {
      playSfx('dice');
    }

    prevFirstRollsRef.current = {
      player1Roll: curr.player1Roll,
      player2Roll: curr.player2Roll,
    };
  }, [longFirstRolls, playSfx]);


    useEffect(() => {
    const onConnect = () => setIsSocketDown(false);
    const onDisconnect = () => setIsSocketDown(true);
    const onConnectError = () => setIsSocketDown(true);
    const onReconnectAttempt = () => setIsSocketDown(true);
    const onReconnect = () => setIsSocketDown(false);

    longTournamentSocket.on('connect', onConnect);
    longTournamentSocket.on('disconnect', onDisconnect);
    longTournamentSocket.on('connect_error', onConnectError);
    longTournamentSocket.on('reconnect_attempt', onReconnectAttempt);
    longTournamentSocket.on('reconnect', onReconnect);

    return () => {
      longTournamentSocket.off('connect', onConnect);
      longTournamentSocket.off('disconnect', onDisconnect);
      longTournamentSocket.off('connect_error', onConnectError);
      longTournamentSocket.off('reconnect_attempt', onReconnectAttempt);
      longTournamentSocket.off('reconnect', onReconnect);
    };
  }, []);


  /* ===================== Рендер ===================== */
  const opponentOff = longMyColor === 'white' ? longBlackOffBoard : longWhiteOffBoard;
  const myOff       = longMyColor === 'white' ? longWhiteOffBoard : longBlackOffBoard;

  return (
    <div className="board-wrapper long-tournament">

{isSocketDown && (
        <div className="net-banner">
          ⚠️ {translate('jackpotBoard.connectionLostLong')}
        </div>
      )}
      
      {/* Сообщение об ошибке структуры (без раннего return — хуки стабильны) */}
      {!boardValid && (
        <div style={{ color: 'red', margin: '8px 0' }}>
          {translate('jackpotBoard.invalidBoard')}
        </div>
      )}

      {/* Кнопки в левом верхнем углу */}
      <div className="table-actions">
        {onResign && (
          <button
            className="btn btn--resign"
            onClick={onResignSfx}
            disabled={!!resignDisabled}
            title={translate('jackpotBoard.resignTitle')}
          >
            <span className="btn-ico">🏳️</span> {translate('jackpotBoard.resign')}
          </button>
        )}
        {typeof longLeaveTable === 'function' && (
          <button className="btn btn--leave" onClick={longLeaveTable}>
            {translate('jackpotBoard.lobby')}
          </button>
        )}
      </div>

      {/* ЛЕВАЯ аватарка + подписи */}
      <div className="avatar avatar-left">
        <img
          src={p1Src || DEFAULT_AVATAR}
          alt="player1 avatar"
          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = DEFAULT_AVATAR; }}
        />
      </div>
      <div className="player-info-left">
        <div className="player-name">{p1Name}</div>
        <div className="player-rating">{Number.isFinite(p1.rating) ? p1.rating : '—'}</div>
        <div className={`player-time ${longCurrentTurn === 'player1' ? 'active' : ''}`}>
          {fmt(player1Time)}
        </div>
      </div>

      {/* ПРАВАЯ аватарка + подписи */}
      <div className="avatar avatar-right">
        <img
          src={p2Src || DEFAULT_AVATAR}
          alt="player2 avatar"
          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = DEFAULT_AVATAR; }}
        />
      </div>
      <div className="player-info-right">
        <div className="player-name">{p2Name}</div>
        <div className="player-rating">{Number.isFinite(p2.rating) ? p2.rating : '—'}</div>
        <div className={`player-time ${longCurrentTurn === 'player2' ? 'active' : ''}`}>
          {fmt(player2Time)}
        </div>
      </div>




{/* Заголовок турнира: стадия + приз */}
{/* {(tournamentStageLabel || tournamentPrize != null) && (
  <div className="tourni-header">
    {tournamentStageLabel && (
      <span className={`stage-badge ${stageClass}`}>
        {tournamentStageLabel}
      </span>
    )}
    {tournamentPrize != null && (
      <span className="prize-badge">
        🏅 Приз: {formatPrize(tournamentPrize)}
      </span>
    )}
  </div>
)} */}

      {/* САМА ДОСКА */}
      <div className="board">
              <div className="tbd-stagebarLong">
  {tournamentStageLabel && <div className={`tbd-stageLong ${stageClass}`}>{displayStageLabel}</div>}
  {tournamentPrize != null && <div className="tbd-prizeLong">🏅 {formatPrize(tournamentPrize)}</div>}
</div>
        <img src="/img/Board33.png" alt="Board" />

        {/* Первый бросок (кто начинает) */}
        {longFirstRolls && (
          <div className="first-rolls-display">
            {Number.isInteger(longFirstRolls?.player1Roll) && (
              <img
                src={diceImages.white[longFirstRolls.player1Roll]}
                alt={translate('jackpotBoard.firstRollP1', { value: longFirstRolls.player1Roll })}
                className="dice-image first-roll-player1"
              />
            )}
            {Number.isInteger(longFirstRolls?.player2Roll) && (
              <img
                src={diceImages.black[longFirstRolls.player2Roll]}
                alt={translate('jackpotBoard.firstRollP2', { value: longFirstRolls.player2Roll })}
                className="dice-image first-roll-player2"
              />
            )}
          </div>
        )}

        {/* Кнопка «Бросить кубики» */}
        {longRollEnabled && (
          <button className="roll-dice-button" onClick={handleLongRollDiceClickSfx}>
            {translate('jackpotBoard.rollDice')}
          </button>
        )}

        {/* Выпавшие кубики текущего игрока */}
        {Array.isArray(longRolledDice) && longRolledDice.length > 0 && longFirstMoveComplete && (
          <div className="dice-display">
            {longRolledDice.map((val, idx) => {
              const turnColor = longCurrentTurn === 'player1' ? 'white' : 'black';
              return <img key={idx} src={diceImages[turnColor][val]} alt={`Dice ${val}`} />;
            })}
          </div>
        )}

        {/* Отмена хода */}
        {longShowUndoButton && (
          <button className="undo-button" onClick={longHandleUndoMoveSfx}>
            {translate('jackpotBoard.undo')}
          </button>
        )}

        {/* Подтвердить ход */}
        {canConfirmMove && (
         <button className="long-ok-button" onClick={longConfirmMoveSfx}>
          <img src="/img/Ok.png" alt={translate('jackpotBoard.finishMove')} />
        </button>
        )}

        {/* Ряды фишек */}
        {longMyColor === 'white' ? (
          <>
            {renderWhiteTopRow()}
            {renderWhiteBottomRow()}
          </>
        ) : (
          <>
            {renderBlackTopRow()}
            {renderBlackBottomRow()}
          </>
        )}

        {/* Бар и выходные фишки */}
        <div className="bar" />
        <div className="off-board">
          {/* верх — соперник */}
          <div className="off-board-opponent">
            {(opponentOff || []).map((checker, i) => (
              <div key={i} className={`checker ${checker?.color || (longMyColor === 'white' ? 'black' : 'white')}`} />
            ))}
          </div>
          {/* низ — мои */}
          <div className="off-board-my">
            {(myOff || []).map((checker, i) => (
              <div key={i} className={`checker ${checker?.color || longMyColor}`} />
            ))}
          </div>
        </div>

        {/* Если доска некорректна — подсказка прямо на экране */}
        {!boardValid && (
          <div style={{ marginTop: 12, color: '#fffa' }}>
            {translate('jackpotBoard.invalidBoardHint')}
          </div>
        )}




        
      </div>
          
  <div
  
    className="auto-actions"
    style={{
      position: 'fixed',
      bottom: 16,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1500,          // выше доски/куба/хедеров
      display: 'flex',
      gap: 12,
      pointerEvents: 'auto', // на всякий
      margin: 0
    }}
    role="group"
    aria-label={translate('jackpotBoard.autoSettings')}
  >
    {longFirstMoveComplete && longFirstRolls &&
    <button
      type="button"
      className={`auto-btn ${autoRoll ? 'on' : ''}`}
      onClick={onToggleAutoRoll}
    >
      <span className="dot" aria-hidden="true" />
      {translate('jackpotBoard.autoRoll')}: {autoRoll ? translate('jackpotBoard.on') : translate('jackpotBoard.off')}
    </button>
}
{longFirstMoveComplete && longFirstRolls &&
    <button
      type="button"
      className={`auto-btn ${autoConfirm ? 'on' : ''}`}
      onClick={onToggleAutoConfirm}
    >
      <span className="dot" aria-hidden="true" />
      {translate('jackpotBoard.autoConfirm')}: {autoConfirm ? translate('jackpotBoard.on') : translate('jackpotBoard.off')}
    </button>
}
  </div>


 
    </div>
  );
};

export default LongTournamentBackgammonBoardDisplay;




// import React, { useEffect } from 'react';
// import './Board.css';

// const LongTournamentBackgammonBoardDisplay = ({
//   // ---- Ваши пропсы ----
//   longBoardState,
//   longOnPointClick,
//   longHandleDragOver,
//   longHandleDragStart,
//   longHandleDrop,
//   longFirstRolls,
//   longHasRolledDice,
//   firstMoveComplete,
//   longCurrentTurn,
//   longMyColor = 'white', // 'white' или 'black'
//   longRolledDice,
//   longShowUndoButton,
//   longHandleUndoMove,
//   longNumberMove,
//   longConfirmMove,
//   handleLongRollDiceClick,
//   longWhiteOffBoard,
//   longBlackOffBoard,
//   longFirstMoveComplete,
//   longLeaveTable,
//   longMoveHistory,
//   longRollEnabled,
//   player1Time,
//   player2Time,
//   onResign,
//   resignDisabled,
//  player1Profile,
//  player2Profile,
//  longPlayer1Name,
// longPlayer2Name
//   // ... и т.д.
// }) => {




//   // ↓ где-нибудь сразу после объявления пропсов/хелперов:
// const p1 = player1Profile || {};
// const p2 = player2Profile || {};

// const p1Name = longPlayer1Name ?? p1.name ?? p1.username ?? 'Player 1';
// const p2Name = longPlayer2Name ?? p2.name ?? p2.username ?? 'Player 2';


// // === avatar utils (НОВЫЙ, без двойного http) ===

// // 1) Берём из env полный origin, если он уже задан
// const RAW_API =
//   (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_API_ORIGIN || import.meta.env?.VITE_API_URL)) ||
//   process.env.REACT_APP_API_ORIGIN ||
//   process.env.REACT_APP_API_URL ||
//   '';

// // 2) Бэкапы из страницы (если env пустые)
// const PAGE_PROTOCOL = (typeof window !== 'undefined' && window.location?.protocol) || 'http:';
// const PAGE_HOST     = (typeof window !== 'undefined' && window.location?.hostname) || 'localhost';
// const ENV_PORT =
//   (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_PORT) ||
//   process.env.REACT_APP_PORT ||
//   (typeof window !== 'undefined' && window.location?.port === '3001' ? '5000' : '');

// // 3) Сборка корректного ORIGIN без «http://http://»
// let API_ORIGIN = '';
// if (/^https?:\/\//i.test(RAW_API)) {
//   // уже полный URL → просто убираем хвостовые слэши
//   API_ORIGIN = RAW_API.replace(/\/+$/, '');
// } else if (RAW_API) {
//   // например "147.93.123.26" или "147.93.123.26:5000"
//   const hasPort = /:\d+$/.test(RAW_API);
//   API_ORIGIN = `${PAGE_PROTOCOL}//${RAW_API}${hasPort ? '' : (ENV_PORT ? `:${ENV_PORT}` : '')}`.replace(/\/+$/, '');
// } else {
//   // вообще нет env → используем хост страницы
//   API_ORIGIN = `${PAGE_PROTOCOL}//${PAGE_HOST}${ENV_PORT ? `:${ENV_PORT}` : ''}`.replace(/\/+$/, '');
// }

// // 96×96 серый кружок "BQ"
// const DEFAULT_AVATAR =
//   'data:image/svg+xml;utf8,' +
//   encodeURIComponent(
//     `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96">
//        <circle cx="48" cy="48" r="46" fill="#2b2b2b" stroke="#999" stroke-width="2"/>
//        <text x="50%" y="54%" text-anchor="middle" font-family="Inter,Arial" font-size="28" fill="#ddd">BQ</text>
//      </svg>`
//   );

// // Превращаем raw → абсолютный URL
// function resolveAvatarSrc(raw) {
//   const s = String(raw || '').replace(/\\/g, '/').trim();
//   if (!s) return DEFAULT_AVATAR;

//   // если уже абсолютный — отдаем как есть
//   if (/^https?:\/\//i.test(s)) return s;

//   // типичный путь статики бэка
//   if (/^\/?uploads\//i.test(s) || /^\/?api\/uploads\//i.test(s)) {
//     return `${API_ORIGIN}/${s.replace(/^\/+/, '')}`;
//   }

//   // иначе считаем, что это файл из public фронта
//   return s.startsWith('/') ? s : `/${s}`;
// }

// // Готовые ссылки для img
// const p1Src = resolveAvatarSrc(player1Profile?.avatar);
// const p2Src = resolveAvatarSrc(player2Profile?.avatar);


// // Логи один раз на изменения входных данных
// // useEffect(() => {
// //   console.log('[AVATAR][effect] API_ORIGIN =', 
// //     import.meta?.env?.VITE_API_ORIGIN || process.env.REACT_APP_API_ORIGIN || '');
// //   console.log('[AVATAR][effect] player1Profile =', player1Profile);
// //   console.log('[AVATAR][effect] player2Profile =', player2Profile);
// //   console.log('[AVATAR][effect] raw p1.avatar =', player1Profile?.avatar);
// //   console.log('[AVATAR][effect] raw p2.avatar =', player2Profile?.avatar);
// //   console.log('[AVATAR][effect] resolved p1Src =', p1Src);
// //   console.log('[AVATAR][effect] resolved p2Src =', p2Src);
// // }, [player1Profile, player2Profile, p1Src, p2Src]);

// // // Лог на каждый рендер
// // console.log('[AVATAR][render] p1Src =', p1Src, ' | p2Src =', p2Src);



// // Пробуем руками скачать картинки, чтобы увидеть успех/ошибку
// useEffect(() => {
//   const test = (label, url) => {
//     if (!url || url === DEFAULT_AVATAR) {
//       console.warn(`[AVATAR][probe] ${label}: url пустой или дефолт →`, url);
//       return;
//     }
//     const img = new Image();
//     img.onload  = () => console.log(`[AVATAR][probe] ${label}: OK 200 →`, url);
//     img.onerror = (e) =>  console.warn(`[AVATAR][probe] ${label}: ERROR →`, url, e);
//     img.src = url;
//   };
//   test('P1', p1Src);
//   test('P2', p2Src);
// }, [p1Src, p2Src]);


//   // Разделяем массив на 2 части, как в вашем коде (но не забываем, что .reverse()):
//   const firstBlack = Array.isArray(longBoardState) && longBoardState.length >= 24
//     ? longBoardState.slice(0, 12)        // индексы [0..11]
//     : [];
//   const secondBlack = Array.isArray(longBoardState) && longBoardState.length >= 24
//     ? longBoardState.slice(12)     // индексы [23..12]
//     : [];
//   const firstWhite = Array.isArray(longBoardState) && longBoardState.length >= 24
//     ? longBoardState.slice(12)              // индексы [12..23]
//     : [];
//   const secondWhite = Array.isArray(longBoardState) && longBoardState.length >= 24
//     ? longBoardState.slice(0, 12).reverse()  // индексы [11..0]
//     : [];


// function OffBoardStack({ checkers, color }) {
//   return (
//     <div className="off-stack">
//       {checkers.map((_, i) => (
//         <div key={i} className={`checker ${color}`} />
//       ))}
//     </div>
//   );
// }



// function fmt(sec) {
//   const m = String(Math.floor(sec / 60)).padStart(2, '0');
//   const s = String(sec % 60).padStart(2, '0');
//   return `${m}:${s}`;
// }

// console.log('[C‑4] props.longBoardState len=', longBoardState.length);

//     //   // Карты картинок кубиков
//   const diceImages = {
//     white: {
//       1: '/img/k1-white-1.png',
//       2: '/img/k1-white-2.png',
//       3: '/img/k1-white-3.png',
//       4: '/img/k1-white-4.png',
//       5: '/img/k1-white-5.png',
//       6: '/img/k1-white-6.png',
//     },
//     black: {
//       1: '/img/k1-black-1.png',
//       2: '/img/k1-black-2.png',
//       3: '/img/k1-black-3.png',
//       4: '/img/k1-black-4.png',
//       5: '/img/k1-black-5.png',
//       6: '/img/k1-black-6.png',
//     },
//   };



// const isMyTurn =
//   (longMyColor === 'white' && longCurrentTurn === 'player1') ||
//   (longMyColor === 'black' && longCurrentTurn === 'player2');

// // const canConfirmMove =
// //   isMyTurn &&
// //   longHasRolledDice === true &&
// //   longNumberMove === 0 &&
// //   longMoveHistory.length > 0;

// const canConfirmMove =
//   isMyTurn &&
//   longHasRolledDice &&
//   longNumberMove === 0 
//   // (longMoveHistory.length > 0 ||             // были ходы
//   //  usableCount === 0);  


//   // --------------------------------------------------------------------------
//   // 1. РЕНДЕР ФУНКЦИЙ ДЛЯ БЕЛОГО (НЕ МЕНЯЕМ — КАК У ВАС)
//   // --------------------------------------------------------------------------
// if (!Array.isArray(longBoardState) || longBoardState.length !== 24) {
//   return <div style={{ color: 'red' }}>Ошибка: некорректная структура доски.</div>;
// }


// // ⬇️ ХЕЛПЕР: рисуем не больше 5 шашек и показываем число поверх
// function renderStackedCheckers(point, { isTopRow, realIndex }) {
//   const checkers = Array.isArray(point) ? point : [];
//   const visible  = checkers.slice(0, 5);          // максимум 5
//   const total    = checkers.length;

//   return visible.map((checker, i) => {
//     if (!checker || !checker.color) return null;
//     const color = String(checker.color).toLowerCase();

//     // где показывать число:
//     //   верхний ряд  → на ПОСЛЕДНЕЙ видимой
//     //   нижний ряд   → на ПЕРВОЙ видимой
//     const showCount = total > 5
//       ? (isTopRow ? i === visible.length - 1 : i === 0)
//       : false;

//     return (
//       <div
//         key={i}
//         className={`checker ${color}`}
//         draggable="true"
//         onDragStart={(e) => longHandleDragStart(e, realIndex, i)}
//         style={{
//           position: 'relative',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//         }}
//       >
//         {showCount && <span className="stack-count">{total}</span>}
//       </div>
//     );
//   });
// }





//   const renderWhiteTopRow = () => {
//     // firstWhite => индексы [12..23], НЕ reverse
//     return (
//       <div className="top-row">
//         {(firstWhite || []).map((point, idx) => {
//           // Пример: idx=0 => это физ. индекс=12, idx=11 => физ. индекс=23
//           const realIndex = 24 - idx - 1; // ваше прежнее вычисление (24 - 0 - 1=23)
//           return (
//             <div
//               key={idx}
//               className={`point-container p${idx}`}
//               onClick={() => {
//                 // console.log(`(white) Clicked top row point realIndex=${realIndex}`);
//                 longOnPointClick(realIndex);
//               }}
//               onDragOver={longHandleDragOver}
//               onDrop={(e) => longHandleDrop(e, realIndex)}
//             >
//               <span>{idx + 13}</span>

//               {renderStackedCheckers(point, { isTopRow: true, realIndex })}


//              {/* {(Array.isArray(point) ? point : []).map((checker, checkerIndex) => {
//                 if (!checker || !checker.color) return null;
//                 const checkerColor = checker.color.toLowerCase();
//                 // console.log(`[CHECKER] row=black bottom realIndex=${realIndex} → color=${checkerColor}`);
//                 return (
//                   <div
//                     key={checkerIndex}
//                     className={`checker ${checkerColor}`}
//                     draggable="true"
//                     onDragStart={(e) => longHandleDragStart(e, realIndex, checkerIndex)}
//                   />
//                 );
//               })} */}
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   const renderWhiteBottomRow = () => {
//     // secondWhite => индексы [11..0], реверснутый slice(0..12)
//     return (
//       <div className="bottom-row">
//         {(secondWhite || []).map((point, idx) => {
//           // idx=0 => физ. индекс=11, idx=11 => физ. индекс=0
//           const realIndex = idx; // потому что, судя по вашему коду, longOnPointClick(index)
//           return (
//             <div
//               key={idx}
//               className={`point-containerd r${idx}`}
//               onClick={() => {
//                 // console.log(`(white) Clicked bottom row point realIndex=${realIndex}`);
//                 longOnPointClick(realIndex);
//               }}
//               onDragOver={longHandleDragOver}
//               onDrop={(e) => longHandleDrop(e, realIndex)}
//             >

//               {renderStackedCheckers(point, { isTopRow: false, realIndex })}

//             {/* {(Array.isArray(point) ? point : []).map((checker, checkerIndex) => {
//                 if (!checker || !checker.color) return null;
//                 const checkerColor = checker.color.toLowerCase();
//                 // console.log(`[CHECKER] row=black bottom realIndex=${realIndex} → color=${checkerColor}`);
//                 return (
//                   <div
//                     key={checkerIndex}
//                     className={`checker ${checkerColor}`}
//                     draggable="true"
//                     onDragStart={(e) => longHandleDragStart(e, realIndex, checkerIndex)}
//                   />
//                 );
//               })} */}
//               <span>{12 - idx}</span>
//             </div>
//           );
//         })}
//       </div>
//     );
//   };



//   // --------------------------------------------------------------------------
//   // 2. РЕНДЕР ДЛЯ ЧЁРНОГО (ПЕРЕВЁРНУТО)
//   // --------------------------------------------------------------------------
//   //
//   // Нужно, чтобы чёрные шашки (физ. [0..11]) виднелись "сверху",
//   // а белые (физ. [12..23]) — снизу. То есть для чёрного:
//   //   topRow => firstBlack (но обычно "развернём" слева-направо),
//   //   bottomRow => secondBlack (тоже смотреть, нужно ли разворачивать).
//   //
//   // ВАЖНО: в вашем примере secondBlack уже reversed, поэтому
//   // firstBlack = [0..11] (без reverse)
//   // secondBlack = [23..12] (reverse)
//   //
//   // Если хотим, чтобы чёрные в "topRow" шли СЛЕВА=24 -> ПРАВО=13,
//   // можем тоже сделать reverse.
//   // А если хотим просто "как есть", можно обойтись без reverse.








//   const renderBlackTopRow = () => {
//     // Предположим, хотим, чтобы "левый верх" был физ. индекс=11, "правый верх" физ. индекс=0
//     // => значит надо реверснуть firstBlack, и при map (idx=0) => realIndex=11.
//     const blackTopReversed = [...firstBlack].reverse();
//     return (
//       <div className="top-row">
//         {blackTopReversed.reverse().map((point, idx) => {
//           // idx=0 => point= firstBlack[11], физ. индекс=11
//           // idx=1 => point= firstBlack[10], физ. индекс=10
//           // ...
//           // => realIndex = 11 - idx
//           const realIndex = 11 - idx;
//           const label = 13 + idx ; // для красоты

//           return (
//             <div
//               key={idx}
//               className={`point-container p${idx}`}
//               onClick={() => {
//                 // console.log(`(black) top row: click idx=${idx}, realIndex=${realIndex}`);
//                 longOnPointClick(realIndex);
//               }}
//               onDragOver={longHandleDragOver}
//               onDrop={(e) => longHandleDrop(e, realIndex)}
//             >
//               <span>{label}</span>
//               {renderStackedCheckers(point, { isTopRow: true, realIndex })}

//             {/* {(Array.isArray(point) ? point : []).map((checker, checkerIndex) => {
//                 if (!checker || !checker.color) return null;
//                 const checkerColor = checker.color.toLowerCase();
//                 // console.log(`[CHECKER] row=black bottom realIndex=${realIndex} → color=${checkerColor}`);
//                 return (
//                   <div
//                     key={checkerIndex}
//                     className={`checker ${checkerColor}`}
//                     draggable="true"
//                     onDragStart={(e) => longHandleDragStart(e, realIndex, checkerIndex)}
//                   />
//                 );
//               })} */}
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   const myOffBoard = longMyColor === 'white' ? longWhiteOffBoard : longBlackOffBoard;
// const opponentOffBoard = longMyColor === 'white' ? longBlackOffBoard : longWhiteOffBoard;


//   const renderBlackBottomRow = () => {
//     // secondBlack уже является reverse(slice(12))
//     // => secondBlack[0] = физ. индекс=23,
//     //    secondBlack[1] = физ. индекс=22, ...,
//     //    secondBlack[11] = физ. индекс=12
//     // Если хотим, чтобы левый нижний был физ. индекс=12, а правый нижний=23,
//     // нам надо ВНОВЬ реверснуть, чтобы «раскрутить» обратно.
//     const blackBottomUnReversed = [...secondBlack].reverse(); 
//     // теперь blackBottomUnReversed[0] = физ. 12,
//     //      blackBottomUnReversed[11] = физ. 23

//     return (
//       <div className="bottom-row">
//         {blackBottomUnReversed.map((point, idx) => {
//           // idx=0 => физ. индекс=12, idx=1 => 13, ... idx=11 => 23
//           const realIndex = 12 + idx;
//           const label = 12 - idx; // 1..12
//           return (
//             <div
//               key={idx}
//               className={`point-containerd r${idx}`}
//               onClick={() => {
//                 // console.log(`(black) bottom row: click idx=${idx}, realIndex=${realIndex}`);
//                 longOnPointClick(realIndex);
//               }}
//              onDragOver={longHandleDragOver}
//               onDrop={(e) => longHandleDrop(e, realIndex)}
//             >
//               {renderStackedCheckers(point, { isTopRow: false, realIndex })}

//             {/* {(Array.isArray(point) ? point : []).map((checker, checkerIndex) => {
//                 if (!checker || !checker.color) return null;
//                 const checkerColor = checker.color.toLowerCase();
//                 // console.log(`[CHECKER] row=black bottom realIndex=${realIndex} → color=${checkerColor}`);
//                 return (
//                   <div
//                     key={checkerIndex}
//                     className={`checker ${checkerColor}`} 
//                     draggable="true"
//                     onDragStart={(e) => longHandleDragStart(e, realIndex, checkerIndex)}
//                   />
//                 );
//               })} */}
//               <span>{label}</span>
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   // --------------------------------------------------------------------------
//   // САМ РЕНДЕР
//   // --------------------------------------------------------------------------
// //   return (
// //     <div className="board">
// //       <img src="/img/Board.png" alt="Board" />
// //   {/* Рендер "первого броска" (если первый ход не завершён) */}
// //          { longFirstRolls && (
// //         <div className="first-rolls-display">
// //           {Number.isInteger(longFirstRolls?.player1Roll) && (
// //             <img
// //               src={diceImages.white[longFirstRolls.player1Roll]}
// //               alt={translate('jackpotBoard.firstRollP1', { value: longFirstRolls.player1Roll })}
// //               className="dice-image first-roll-player1"
// //             />
// //           )}
// //           {Number.isInteger(longFirstRolls?.player2Roll) && (
// //             <img
// //               src={diceImages.black[longFirstRolls.player2Roll]}
// //               alt={translate('jackpotBoard.firstRollP2', { value: longFirstRolls.player2Roll })}
// //               className="dice-image first-roll-player2"
// //             />
// //           )}
// //         </div> 
// //       )}
// //       {/* (Пример) отрисовка кубиков, кнопок, и т.д. */}

// //       {longMyColor === 'white'
// //         ? (
// //           <>
// //           {/* Кнопка "Бросить кубики" — если кубики ещё не брошены, ход ваш, и первый ход завершён */}
// // {!longHasRolledDice && longFirstMoveComplete && (
// //   <button className="roll-dice-button" onClick={handleLongRollDiceClick}>
// //     Бросить кубики (Long)
// //   </button>
// // )}

// // {/*  Отображение выпавших кубиков (longRolledDice) */ }
// // {longRolledDice && longRolledDice.length > 0 && firstMoveComplete && (
// //   <div className="dice-display">
// //     {longRolledDice.map((val, idx) => (
// //       <img
// //         key={idx}
// //         src={
// //           longCurrentTurn === (longMyColor === 'white' ? 'player1' : 'player2')
// //             ? diceImages[longMyColor][val]
// //             : diceImages[longMyColor === 'white' ? 'black' : 'white'][val]
// //         }
// //         alt={`Dice ${val}`}
// //       />
// //     ))}
// //   </div>
// // )}

// // {/* Кнопка "Отменить" (undo) */}
// // {longShowUndoButton && (
// //   <button className="undo-button" onClick={longHandleUndoMove}>
// //     Отмена
// //   </button>
// // )}

// // {/* Кнопка "Завершить ход" — если это ваш ход и numberMove=0 */}
// // {longCurrentTurn === (longMyColor === 'white' ? 'player1' : 'player2')
// //  && longNumberMove === 0 && (
// //   <button className="ok-button" onClick={longConfirmMove}>
// //     <img src="/img/Ok.png" alt={translate('jackpotBoard.finishMove')} />
  
// //   </button>
// // )}

// //             {renderWhiteTopRow()}
// //             {renderWhiteBottomRow()}
// //           </>
// //         )
// //         : (
// //           <>
// //             {renderBlackTopRow()}
// //             {renderBlackBottomRow()}
// //           </>
// //         )
// //       }

// //       {/* Бар, офф-борд и т.д. */}
// //       <div className="bar" />
// //       <div className="off-board" />
// //     </div>


// //Отображение кубиков обоих игроков!!!!

// return (
//   <div className="board-wrapper long-tournament">
//     {/* Кнопки в левом верхнем углу */}
//     <div className="table-actions">
//       {onResign && (
//         <button
//           className="btn btn--resign"
//           onClick={onResign}
//           disabled={!!resignDisabled}
//           title="Сдаться и завершить партию"
//         >
//           <span className="btn-ico">🏳️</span> Сдаться
//         </button>
//       )}
//       {typeof longLeaveTable === 'function' && (
//         <button className="btn btn--leave" onClick={longLeaveTable}>
//           В лобби
//         </button>
//       )}
//     </div>

//     {/* ЛЕВАЯ аватарка + подписи */}
//     <div className="avatar avatar-left">
//       <img
//         src={p1Src || DEFAULT_AVATAR}
//         alt="player1 avatar"
//         onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = DEFAULT_AVATAR; }}
//       />
//     </div>
//     <div className="player-info-left">
//       <div className="player-name">{p1Name}</div>
//       <div className="player-rating">{Number.isFinite(p1.rating) ? p1.rating : '—'}</div>
//       <div className={`player-time ${longCurrentTurn === 'player1' ? 'active' : ''}`}>
//         {fmt(player1Time)}
//       </div>
//     </div>

//     {/* ПРАВАЯ аватарка + подписи */}
//     <div className="avatar avatar-right">
//       <img
//         src={p2Src || DEFAULT_AVATAR}
//         alt="player2 avatar"
//         onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = DEFAULT_AVATAR; }}
//       />
//     </div>
//     <div className="player-info-right">
//       <div className="player-name">{p2Name}</div>
//       <div className="player-rating">{Number.isFinite(p2.rating) ? p2.rating : '—'}</div>
//       <div className={`player-time ${longCurrentTurn === 'player2' ? 'active' : ''}`}>
//         {fmt(player2Time)}
//       </div>
//     </div>

//     {/* САМА ДОСКА */}
//     <div className="board">
//       <img src="/img/Board.png" alt="Board" />

//       {/* Первый бросок (кто начинает) */}
//       {longFirstRolls && (
//         <div className="first-rolls-display">
//           {Number.isInteger(longFirstRolls?.player1Roll) && (
//             <img
//               src={diceImages.white[longFirstRolls.player1Roll]}
//               alt={translate('jackpotBoard.firstRollP1', { value: longFirstRolls.player1Roll })}
//               className="dice-image first-roll-player1"
//             />
//           )}
//           {Number.isInteger(longFirstRolls?.player2Roll) && (
//             <img
//               src={diceImages.black[longFirstRolls.player2Roll]}
//               alt={translate('jackpotBoard.firstRollP2', { value: longFirstRolls.player2Roll })}
//               className="dice-image first-roll-player2"
//             />
//           )}
//         </div>
//       )}

//       {/* Кнопка «Бросить кубики» */}
//       {longRollEnabled && (
//         <button className="roll-dice-button" onClick={handleLongRollDiceClick}>
//           Бросить кубики
//         </button>
//       )}

//       {/* Выпавшие кубики текущего игрока */}
//       {Array.isArray(longRolledDice) && longRolledDice.length > 0 && longFirstMoveComplete && (
//         <div className="dice-display">
//           {longRolledDice.map((val, idx) => {
//             const turnColor = longCurrentTurn === 'player1' ? 'white' : 'black';
//             return <img key={idx} src={diceImages[turnColor][val]} alt={`Dice ${val}`} />;
//           })}
//         </div>
//       )}

//       {/* Отмена хода */}
//       {longShowUndoButton && (
//         <button className="undo-button" onClick={longHandleUndoMove}>
//           Отмена
//         </button>
//       )}

//       {/* Подтвердить ход */}
//       {canConfirmMove && (
//         <button className="ok-button" onClick={longConfirmMove}>
//           <img src="/img/Ok.png" alt={translate('jackpotBoard.finishMove')} />
//         </button>
//       )}

//       {/* Ряды фишек */}
//       {longMyColor === 'white' ? (
//         <>
//           {renderWhiteTopRow()}
//           {renderWhiteBottomRow()}
//         </>
//       ) : (
//         <>
//           {renderBlackTopRow()}
//           {renderBlackBottomRow()}
//         </>
//       )}

//       {/* Бар и выходные фишки */}
//       <div className="bar" />
//       <div className="off-board">
//         {/* верх — соперник */}
//         <div className="off-board-opponent">
//           {Array.isArray(
//             longMyColor === 'white' ? longBlackOffBoard : longWhiteOffBoard
//           ) &&
//             (longMyColor === 'white' ? longBlackOffBoard : longWhiteOffBoard).map((checker, i) => (
//               <div key={i} className={`checker ${checker?.color || 'black'}`} />
//             ))}
//         </div>
//         {/* низ — мои */}
//         <div className="off-board-my">
//           {Array.isArray(longMyColor === 'white' ? longWhiteOffBoard : longBlackOffBoard) &&
//             (longMyColor === 'white' ? longWhiteOffBoard : longBlackOffBoard).map((checker, i) => (
//               <div key={i} className={`checker ${checker?.color || 'white'}`} />
//             ))}
//         </div>
//       </div>
//     </div>
//   </div>
// );
// }















// // return (
  
// // <div className="board-wrapper" style={{ border: '2px solid red', paddingTop: '60px' }}>



// // <div className="table-actions">
// //   {onResign && (
// //     <button
// //       className="btn btn--resign"
// //       onClick={onResign}
// //       disabled={!!resignDisabled}
// //       title="Сдаться и завершить партию"
// //     >
// //       <span className="btn-ico">🏳️</span> Сдаться
// //     </button>
// //   )}
// //   {typeof longLeaveTable === 'function' && (
// //     <button className="btn btn--leave" onClick={longLeaveTable}>
// //       В лобби
// //     </button>
// //   )}
// // </div>

// //      {/* <button className="exitTable" onClick={longLeaveTable}>Покинуть стол</button>  */}
    




// //     {/* ⬇️ ЛЕВАЯ сторона (player1) */}
// // <div className="avatar avatar-left">
// //   <img
// //     src={p1Src}
// //     alt="player1 avatar"
// //     onLoad={() => console.log('[AVATAR] P1 onLoad OK →', p1Src)}
// //     onError={(e) => {
// //       console.log('[AVATAR] P1 onError for src =', e.currentTarget.src);
// //       e.currentTarget.onerror = null;            // чтобы не зациклиться
// //       e.currentTarget.src = DEFAULT_AVATAR;      // подмена на дефолт
// //     }}
// //   />
// // </div>

// // {/* НОВОЕ: имя/рейтинг/время под левой авой */}
// // <div className="player-info-left">
// //   <div className="player-name">{(p1.name || p1.username || 'Player 1')}</div>
// //   <div className="player-rating">{Number.isFinite(p1.rating) ? p1.rating : '—'}</div>
// //   <div className={`player-time ${longCurrentTurn === 'player1' ? 'active' : ''}`}>{fmt(player1Time)}</div>
// // </div>

// //     <div
// //       style={{
// //         position: 'absolute',
// //         top: 'calc(50% + 70px)', // подписи под аватаркой
// //         left: 20,
// //         width: 100,
// //         textAlign: 'center',
// //         color: '#fff',
// //         textShadow: '0 1px 2px rgba(0,0,0,.6)',
// //         lineHeight: 1.25,
// //         fontWeight: 700,
// //         pointerEvents: 'none',
// //       }}
// //     >
// //       <div style={{ fontWeight: 800 }}>
// //         {(player1Profile && (player1Profile.name || player1Profile.username)) || 'Player 1'}
// //       </div>
// //       <div>
// //         {Number.isFinite(player1Profile?.rating) ? player1Profile.rating : '—'}
// //       </div>
// //     </div>

// //     {/* ⬇️ ПРАВАЯ сторона (player2) */}
// // <div className="avatar avatar-right">
// //   <img
// //     src={p2Src}
// //     alt="player2 avatar"
// //     onLoad={() => console.log('[AVATAR] P2 onLoad OK →', p2Src)}
// //     onError={(e) => {
// //       console.log('[AVATAR] P2 onError for src =', e.currentTarget.src);
// //       e.currentTarget.onerror = null;
// //       e.currentTarget.src = DEFAULT_AVATAR;
// //     }}
// //   />
// // </div>
// // {/* НОВОЕ: имя/рейтинг/время под правой авой */}
// // <div className="player-info-right">
// //   <div className="player-name">{(p2.name || p2.username || 'Player 2')}</div>
// //   <div className="player-rating">{Number.isFinite(p2.rating) ? p2.rating : '—'}</div>
// //   <div className={`player-time ${longCurrentTurn === 'player2' ? 'active' : ''}`}>{fmt(player2Time)}</div>
// // </div>

// //     <div
// //       style={{
// //         position: 'absolute',
// //         top: 'calc(50% + 70px)',
// //         right: 20,
// //         width: 100,
// //         textAlign: 'center',
// //         color: '#fff',
// //         textShadow: '0 1px 2px rgba(0,0,0,.6)',
// //         lineHeight: 1.25,
// //         fontWeight: 700,
// //         pointerEvents: 'none',
// //       }}
// //     >
// //       <div style={{ fontWeight: 800 }}>
// //         {(player2Profile && (player2Profile.name || player2Profile.username)) || 'Player 2'}
// //       </div>
// //       <div>
// //         {Number.isFinite(player2Profile?.rating) ? player2Profile.rating : '—'}
// //       </div>
// //     </div>


// //   <div className="board">
   
// //     <img src="/img/Board.png" alt="Board" />
   
// //     {/* Первый бросок (до начала игры) */}
// //     {longFirstRolls && (
// //       <div className="first-rolls-display">
// //         {Number.isInteger(longFirstRolls?.player1Roll) && (
// //           <img
// //             src={diceImages.white[longFirstRolls.player1Roll]}
// //             alt={translate('jackpotBoard.firstRollP1', { value: longFirstRolls.player1Roll })}
// //             className="dice-image first-roll-player1"
// //           />
// //         )}
// //         {Number.isInteger(longFirstRolls?.player2Roll) && (
// //           <img
// //             src={diceImages.black[longFirstRolls.player2Roll]}
// //             alt={translate('jackpotBoard.firstRollP2', { value: longFirstRolls.player2Roll })}
// //             className="dice-image first-roll-player2"
// //           />
// //         )}
// //       </div>
// //     )}

// //     {/* Кнопка "Бросить кубики" (если это ваш ход и кубики ещё не брошены) */}
// //     {/* {!longHasRolledDice && longFirstMoveComplete && (
// //       <button className="roll-dice-button" onClick={handleLongRollDiceClick}>
// //         Бросить кубики (Long)
// //       </button>
// //     )} */}
// //     {longRollEnabled && (
// //   <button className="roll-dice-button" onClick={handleLongRollDiceClick}>Бросить кубики</button>
// // )}


// //     {/* Кубики (если есть что показать) */}
// //     {Array.isArray(longRolledDice) && longRolledDice.length > 0 && longFirstMoveComplete &&(
// //       <div className="dice-display">
// //         {longRolledDice.map((val, idx) => {
// //           const currentTurnColor = longCurrentTurn === 'player1' ? 'white' : 'black';
// //           return (
// //             <img
// //               key={idx} 
// //               src={diceImages[currentTurnColor][val]}
// //               alt={`Dice ${val}`}
// //             />
// //           );
// //         })}
// //       </div>
// //     )}

// //     {/* Кнопка "Отмена хода" */}
// //     {longShowUndoButton && (
// //       <button className="undo-button" onClick={longHandleUndoMove}>
// //         Отмена
// //       </button>
// //     )}

// //     {/* Кнопка "Завершить ход" (если это ваш ход и нет оставшихся ходов) */}
// //     {/* {longCurrentTurn === (longMyColor === 'white' ? 'player1' : 'player2') &&
// //       longNumberMove === 0 && ( */}
// //       {/* {longCurrentTurn === (longMyColor === 'white' ? 'player1' : 'player2') &&
// //       longHasRolledDice === true && 
// //       longNumberMove === 0 && (
// //         <button className="ok-button" onClick={longConfirmMove}>
// //           <img src="/img/Ok.png" alt={translate('jackpotBoard.finishMove')} />
// //         </button>
// //       )} */}

// // {canConfirmMove && (
// //   <button className="ok-button" onClick={longConfirmMove}>
// //     <img src="/img/Ok.png" alt={translate('jackpotBoard.finishMove')} />
// //   </button>
// // )}


// //     {/* Ряды фишек */}
// //     {longMyColor === 'white' ? (
// //       <>
// //         {renderWhiteTopRow()}
// //         {renderWhiteBottomRow()}
// //       </>
// //     ) : (
// //       <>
// //         {renderBlackTopRow()}
// //         {renderBlackBottomRow()}
// //       </>
// //     )}

// //     {/* Бар и офф-борд (можно потом вынести в отдельный компонент) */}
// //     {/* <div className="bar" />
// //     <div className="off-board" /> */}
    

// // {/* бар оставляем как есть */}
// //     <div className="bar" />

// //     {/* ----------  ВЫХОДНЫЕ ШАШКИ  ---------- */}
  
// // <div className="off-board">
// //   {/* ВЕРХНИЙ off-board — соперник */}
// //   <div className="off-board-opponent">
// //     {Array.isArray(opponentOffBoard) &&
// //       opponentOffBoard.map((checker, index) => (
// //         <div key={index} className={`checker ${checker?.color || 'black'}`} />
// //       ))}
// //   </div>

// //   {/* НИЖНИЙ off-board — вы сами */}
// //   <div className="off-board-my">
// //     {Array.isArray(myOffBoard) &&
// //       myOffBoard.map((checker, index) => (
// //         <div key={index} className={`checker ${checker?.color || 'white'}`} />
// //       ))}
// //   </div>

// // </div>




// //   </div>
// //   </div>
// // );
// // }










// export default LongTournamentBackgammonBoardDisplay;
